module.exports = __webpack_public_path__ + "img/banner_5.693258ab.jpg";